document.addEventListener("turbo:load", () => {
  const changePasswordButton = document.getElementById("change-password-link");

  if (changePasswordButton) {
    changePasswordButton.addEventListener("click", () => {
      changePasswordButton.style.display = "none";
    });
  }
});
